module.exports = __webpack_public_path__ + "static/media/dollar-sign.a97b1f07.svg";